/* see also theme/mq.css */
export const mq = {
  sm: window.matchMedia('all and (min-width: 30em)'),
  md: window.matchMedia('all and (min-width: 48em)'),
  lg: window.matchMedia('all and (min-width: 61em)'),
  xl: window.matchMedia('all and (min-width: 80em)')
}

export const colors = {
  black: '#261b14',
  white: 'white',
  yellow: '#ffce3a',
  red: '#e73c31',
  blue: '#ADCCCC',
  brown: '#6f4e38',
  green: '#C8C47B',
  greenGif: '#a2e7c9',
  greenGifLight: '#e7f4ec',
  redDesaturated: '#f08b84',
  purple: '#AA86A4',
  blueDark: '#124259',
  blue02: '#6cc4cd',
  blue02Desaturated: '#c6f0f5',
  skinTone: '#F2C2AA',
  greenDark: '#3D7072'
}
